import CrossSectionEditor from "./CrossSectionEditor";

export default function CrossSectionWindow({riverStation}) {
    return (
        <>
            <div style={{display: 'flex', alignItems: 'center', gap: 16}}>
                {
                    riverStation?.base_ui_data ? (
                        <CrossSectionEditor
                            windowName={'cross-section-ui-base'}
                            data={riverStation?.base_ui_data}
                            title={riverStation?.base_title}
                        />
                    ) : (<></>)
                }
                {
                    riverStation?.cmp_ui_data ? (
                        <CrossSectionEditor
                            windowName={'cross-section-ui-cmp'}
                            targetWindow={'cross-section-ui-base'}
                            data={riverStation?.cmp_ui_data}
                            title={riverStation?.cmp_title}
                        />
                    ) : (<></>)
                }
            </div>
        </>
    )
}